export default "__VITE_ASSET__Bp$PV7Uj__"